import { useContext } from 'react'
import { TodayContext } from '../context'

export function useToday() {
  return useContext(TodayContext)
}
